import React from "react";

export function SelectionButton({ emoji, title, subtitle, selected, onClick }) {
  return (
    <button
      onClick={onClick}
      className={`
        w-full p-4 rounded-2xl transition-all duration-200
        flex items-center gap-4 border-2
        ${
          selected
            ? "bg-green-50 border-green-500"
            : "bg-white border-gray-200 text-gray-700"
        }
      `}
    >
      {emoji && <span className="text-2xl">{emoji}</span>}
      <div className="flex-1 text-left">
        <div className="font-medium text-gray-900">{title}</div>
        {subtitle && (
          <div className="text-sm text-gray-500 mt-0.5">{subtitle}</div>
        )}
      </div>
    </button>
  );
}